import { Box, Avatar, Typography } from "@mui/material";
import React from "react";

const Loader = ({ phrase = "", t }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection:"column",
        minHeight: "200px",
      }}
    >
      <Avatar
        src={"/static/loading.png"}
        alt="loader"
        sx={{ width: 40, height: 40}}
      />{" "}
      <Typography variant="body1" fontFamily={"Poppin"}>
        {t(phrase)}
      </Typography>
    </Box>
  );
};

export default Loader;
